import {
  Card,
  CardHeader,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { OPTIONS_LABEL } from '../../../utils/constants';

export default function TestOMRSheet({ numOfAns, questionsArray, updateQuestions }) {
  const renderHead = () => {
    const renderData = [];
    renderData.push(<TableCell />);
    for (let i = 0; i < numOfAns; i += 1) {
      renderData.push(
        <TableCell align="center" key={i}>
          {OPTIONS_LABEL[i]}
        </TableCell>
      );
    }
    return renderData;
  };

  return (
    <Card sx={{ mt: 4 }}>
      <CardHeader title="Fill OMR Sheet" />
      <Table>
        <TableHead>
          <TableRow>{renderHead()}</TableRow>
        </TableHead>
        <TableBody>
          {questionsArray.map((qa, quesIndex) => (
            <TableRow key={qa._id}>
              <TableCell>{qa.questionNumber}</TableCell>
              {qa.options.map((qo) => (
                <TableCell align="center" key={qo._id}>
                  <Radio
                    checked={qo.isSelected}
                    onChange={() => {
                      const newOptions = questionsArray[quesIndex].options.map((op) => {
                        if (op._id === qo._id) {
                          op.isSelected = true;
                        } else {
                          op.isSelected = false;
                        }
                        return op;
                      });
                      questionsArray[quesIndex].options = newOptions;
                      updateQuestions([...questionsArray]);
                    }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}

TestOMRSheet.propTypes = {
  numOfAns: PropTypes.number,
  questionsArray: PropTypes.array,
  updateQuestions: PropTypes.func
};
